var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2627382291556105316(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24c0 13.254-10.746 24-24 24S0 37.254 0 24 10.746 0 24 0s24 10.746 24 24z",
    fill: "#ED3225"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2 23.454L37.257 9.6l-12.91 5.237 5.115 2.964-4.835 8.413-8.373-4.856L8 35.718l4.624 2.682 5.584-9.716 8.373 4.857 7.503-13.055 5.116 2.965v.003z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2627382291556105316);
export default __webpack_public_path__ + "static/media/2627382291556105316.07bb273da6af17b4e96930529aa4aa0c.svg";
export { ForwardRef as ReactComponent };